import { useEffect } from "react";
import useAuth from '../root/useAuth';

const autoLogoutDuration = 15 * 60 * 1000;

const events = [
    "load",
    // "mousemove",
    // "mousedown",
    "click",
    // "scroll",
    // "keypress",
];

const AppLogout = (props) => {
    let timer;
    const { b2cLogout } = useAuth();

    useEffect(() => {
        Object.values(events).forEach((item) => {
            window.addEventListener(item, () => {
                resetTimer();
                handleTimer();
            });
        });
    }, []);

    const resetTimer = (event) => {
        console.log("******* RESET **** ", event)
        if (timer) clearTimeout(timer);
    };

    const handleTimer = () => {
        timer = setTimeout(() => {
            resetTimer();
            Object.values(events).forEach((item) => {
                window.removeEventListener(item, resetTimer);
            });
            logoutAction();
        }, autoLogoutDuration);
    };

    const logoutAction = () => {
        b2cLogout()
    };
    return true;
};

export default AppLogout;

